import type { IUseCase } from 'shared-kernel';
import type { IAuthRepository } from '../../../domain/ports';
import type { ChangePasswordData } from '../../dto/dtos';

export class ChangePasswordUseCase implements IUseCase<ChangePasswordData, void> {
  constructor(
    private readonly authRepository: IAuthRepository,
  ) {}

  async execute(input: ChangePasswordData): Promise<void> {
    const response = await this.authRepository.changePassword(input);

    if (!response.succes) {
      throw new Error(response.message || 'Echec du changement de mot de passe');
    }
  }
}
